import React from 'react'
import Navbar from './Navbar'
import a1 from './images/a1.jpg'
import a2 from './images/a2.jpg'
import a3 from './images/a3.jpg'
import a4 from './images/a4.jpg'
import a5 from './images/a5.jpg'
import a6 from './images/a6.jpg'
import team1 from './images/team1.jpg'
const Index = () => {
    return (
        <div>
            <header id="site-header" class="fixed-top">
                <Navbar></Navbar>
            </header>
            <section class="banner-19">
                <div class="banner-layer">
                    <div class="main-content-top">
                        <div class="container">
                            <div class="main-content">
                                <div class="w3lbanner-left">

                                    <h6>Welcome to AgroGrow</h6>
                                    <h4>Growing your crops, growing your profits</h4>

                                    <a href="about" class="btn btn-style btn-secondary mt-md-5 mt-4">Read More</a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="w3l-about-6 py-5" id="about">
                <div class="container py-lg-5 py-md-3">
                    <div class="row align-items-center">
                        <div class="col-lg-6 pe-lg-5">
                            <h6 class="title-subw3hny">Our Info</h6>
                            <h3 class="title-w3l">Agriculture & Organic Product Form</h3>
                            <p class="mt-md-4 mt-3">Welcome to our agriculture website, where we cultivate knowledge and sow innovation. Explore our digital farm to discover valuable resources, expert insights, and cutting-edge technologies to maximize your yield and grow a sustainable future.</p>
                            <ul class="service-list pt-lg-2 mt-4">

                                <li class="service-link"><a href="#url"><span class="fa fa-check-circle"></span> Fresh
                                    Vegetables</a></li>
                                <li class="service-link"><a href="#url"><span class="fa fa-check-circle"></span>Easy To
                                    access</a></li>
                                <li class="service-link"><a href="#url"><span class="fa fa-check-circle"></span> Professional
                                    Team</a></li>
                            </ul>
                        </div>
                        <div class="HomeAboutImages col-lg-6 mt-lg-0 mt-5">
                            <div class="row position-relative">
                                <div class="col-6">
                                    <img src={a1} alt="" class="radius-image img-fluid" />
                                </div>
                                <div class="col-6 mt-4">
                                    <img src={a2} alt="" class="radius-image img-fluid mb-md-3 mb-2" />
                                    <img src={a3} alt="" class="radius-image img-fluid mt-md-3" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="w3l-grids-3hny py-5" id="grids1">
                <div class="container py-lg-5 py-md-3">
                    <div class="wthree-header-section text-center">
                        <h6 class="title-subw3hny">What We Do</h6>
                        <h3 class="title-w3l mb-4">What We’re Offering</h3>
                    </div>
                    <div class="grids-of-3 row text-center">
                        <div class="col-lg-4 col-md-6 mt-5">
                            <div class="grids3-info">
                                <a href="#service" class="d-block zoom"><img src={a4} alt=""
                                    class="img-fluid radius-image" /></a>
                                <div class="grids-of-3-saas-info">
                                    <h5><a href="#service" class="title">Crop Reccomendation</a></h5>
                                    <p class="saas-para"> Get to know which crop type best suits your soil</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 mt-5">
                            <div class="grids3-info">
                                <a href="#service" class="d-block zoom"><img src={a5} alt=""
                                    class="img-fluid radius-image" /></a>
                                <div class="grids-of-3-saas-info">
                                    <h5><a href="#service" class="title">Fertilizer Reccomendation</a></h5>
                                    <p class="saas-para">Be aware of what type of Fertilizer you must use in your crops reccomendedation</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 mt-5">
                            <div class="grids3-info">
                                <a href="#service" class="d-block zoom"><img src={a6} alt=""
                                    class="img-fluid radius-image" /></a>
                                <div class="grids-of-3-saas-info">
                                    <h5><a href="#service" class="title">Disease Prediction</a></h5>
                                    <p class="saas-para">We will Predict the disease of type your crops can get affected to so you never get depreciated in Profits.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="w3l-index5 py-5" id="about">
                <div class="new-block py-md-5 py-3">
                    <div class="container">
                        <div class="row middle-section align-self">
                            <div class="col-lg-7 video-info pe-lg-5">
                                <div class="title-content text-left">
                                    <h6 class="title-subw3hny">Root With Nature</h6>
                                    <h3 class="title-w3l two pe-lg-5">For Strong economy, develop agriculture </h3>
                                    <p class="mt-3 pe-lg-5">At Root with Nature, we believe in the power of harnessing the earth's natural elements to nurture our agricultural endeavors. Our mission is to foster a deep connection between farmers and the environment, promoting sustainable practices that enhance soil health, biodiversity, and crop resilience.</p>
                                    <a href="contact" class="btn btn-style btn-outline-light mt-sm-5 mt-4">Discover
                                        More</a>
                                </div>
                            </div>
                            <div class="col-lg-5 history-info mt-5 ps-lg-5 align-self">
                                <div class="position-relative mt-lg-0 mt-5 pt-lg-0 pt-5 pb-lg-0 pb-5">
                                    <a href="#small-dialog"
                                        class="popup-with-zoom-anim play-view text-center position-absolute">
                                        <span class="video-play-icon">
                                            <span class="fa fa-play"></span>
                                        </span>
                                    </a>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <section class="w3l-circles py-5" id="circles">
                <div class="container py-md-5 py-2">
                    <div class="row w3l-circles">
                        <div class="col-lg-6 circles-left">
                            <img src={a6} alt="" class="radius-image img-fluid" />
                        </div>
                        <div class="col-lg-6 circles-right mt-lg-0 mt-5 align-self  position-relative">
                            <h6 class="title-subw3hny">Why Us</h6>
                            <h3 class="title-w3l mb-4">Growing Healthy Food</h3>
                            <p class="mb-5">Our advanced algorithms and machine learning models analyze vast amounts of data to provide you with accurate and tailored recommendations for optimized crop selection, efficient fertilizer usage, and proactive disease prevention. Save time, increase productivity, and maximize your yields by leveraging our cutting-edge technology and expertise.</p>
                            <div class="progress-circles-grids">
                                <div class="progress-circles">
                                    <div class="progress-left">
                                        <div class="circle1">
                                            <div id="progress" data-dimension="80" data-text="85%" data-fontsize="18"
                                                data-percent="85" data-fgcolor="#006837" data-bgcolor="#f3f5f4" data-width="10"
                                                data-bordersize="4" data-animationstep="2">
                                            </div>

                                        </div>
                                        <div class="progress-right">
                                            <h4>Organic Solutions</h4>
                                            <p class="mb-lg-5">Get Solutions that are environment friendly.</p>
                                        </div>
                                    </div>

                                </div>
                                <div class="progress-circles">
                                    <div class="progress-left">
                                        <div class="circle1">
                                            <div id="progress1" data-dimension="80" data-text="95%" data-fontsize="18"
                                                data-percent="95" data-fgcolor="#006837" data-bgcolor="#f3f5f4" data-width="10"
                                                data-bordersize="4" data-animationstep="2">
                                            </div>
                                        </div>
                                        <div class="progress-right">
                                            <h4>Quality Agriculture</h4>
                                            <p class="mb-lg-5">Lorem ipsum feugiat dolor sit amet.</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="w3l-testimonials" id="testimonials">
                <div class="cusrtomer-layout py-5">
                    <div class="container py-lg-4 py-md-3 py-2 pb-lg-0">
                        <h5 class="title-subw3hny text-center mb-1">Happy Clients</h5>
                        <h3 class="title-w3l two text-center mb-sm-5 mb-4">Reviews and Testimonials</h3>
                        <div class="testimonial-width">
                            <div id="owl-demo1" class="owl-two owl-carousel owl-theme">
                                <div class="item">
                                    <div class="testimonial-content">
                                        <div class="testimonial">
                                            <i class="fas fa-quote-right"></i>
                                            <blockquote>
                                                <q>With accurate and user-friendly recommendations, I've experienced healthier crops, reduced costs, and increased profitability. I highly recommend AgroGrow to farmers seeking to optimize their agricultural endeavors.</q>
                                            </blockquote>
                                            <i class="fas fa-quote-right"></i>
                                            <div class="testi-des">
                                                <div class="test-img"><img src={team1} class="img-fluid"
                                                    alt="client-img" />
                                                </div>
                                                <div class="peopl align-self">
                                                    <h3>Sanjay Gadwale</h3>
                                                    <p class="indentity">Sehore</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="w3l-stats-main py-5" id="stats">
                <div class="container py-lg-4">
                    <div class="row stats-con">
                        <div class="col-lg-6 stats-content-left pe-lg-5">
                            <div class="stats_info counter_grid1 text-left">
                                <div class="icon stat-icon">
                                    <span class="fas fa-users"></span>
                                    <p class="counter">5233</p>
                                </div>
                                <div class="stat-icon-des text-left">

                                    <h3 class="title-w3l">
                                        Professional Farmers
                                    </h3>
                                    <p class="para-stat">Lorem ipsum viverra feugiat. Pellen tesque libero ut justo,
                                        ultrices in ligula.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 stats-content-left ps-lg-5 mt-lg-0 mt-md-5 mt-4">
                            <div class="stats_info counter_grid1 text-left">
                                <div class="icon stat-icon">
                                    <span class="fas fa-tractor"></span>
                                    <p class="counter">2233</p>
                                </div>
                                <div class="stat-icon-des text-left">
                                    <h3 class="title-w3l">
                                        Best Quality Standards</h3>
                                    <p class="para-stat">Lorem ipsum viverra feugiat. Pellen tesque libero ut justo,
                                        ultrices in ligula.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <footer class="w3l-footer-29-main" />
            <div class="footer-29-w3l py-5">
                <div class="container pt-md-5">
                    <div class="w3l-footer-text-style">
                        <div class="footer-list-cont d-sm-flex align-items-center justify-content-between mb-5">

                            <h2 class="w3logo"><a class="navbar-brand" href="home">
                                Agrow<span class="sub-color">Grow</span>
                            </a></h2>
                            <div class="main-social-footer-29">
                                <ul>
                                    <li><a href="https://facebook.com" class="facebook"><i
                                        class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="https://twitter.com" class="twitter"><i class="fab fa-twitter"></i></a>
                                    </li>
                                    <li><a href="https://instagram.com/_mayank_ahuja" class="instagram"><i
                                        class="fab fa-instagram"></i></a></li>
                                    <li><a href="#linkedin" class="linkedin"><i class="fab fa-linkedin-in"></i></a></li>
                                </ul>

                            </div>
                        </div>
                    </div>
                    <div class="row footer-top-29 pt-lg-5 pt-sm-4">
                        <div class="col-lg-3 col-sm-6">
                            <div class="address-grid">
                                <h5>VIT Bhopal University<br /> Bhopal.</h5>
                                <p class="mt-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                    tempor </p>

                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 mt-sm-0 mt-4 ps-lg-5">
                            <div class="address-grid">
                                <h5>Phone</h5>
                                <h5 class="phone-number-text mt-2"><a href="tel:+91 8305682466">+91 8305682466</a></h5>
                            </div>
                            <div class="address-grid mt-sm-5 mt-4">
                                <h5>E-mail</h5>
                                <h5 class="email-cont-text mt-1"> <a href="mailto:mayankahuja451@gmail.com"
                                    class="mail">mayankahuja451@gmail.com</a></h5>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-6 col-sm-5 footer-list-menu ps-lg-5 mt-lg-0 mt-sm-5 mt-4">
                            <div class="address-grid">
                                <h5 class="mb-4 pb-lg-2">Support</h5>
                                <ul>
                                    <li><a href="#privacy">Privacy Policy</a></li>
                                    <li><a href="#terms"> Terms of Service</a></li>
                                    <li><a href="contact">Contact us</a></li>
                                    <li><a href="#faq">faQ</a></li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="address-grid col-lg-4 col-md-6 col-sm-7 ps-lg-5 mt-lg-0 mt-sm-5 mt-4 w3l-footer-16-main">
                            <h5>Subscribe here</h5>
                            <form action="#" class="subscribe d-flex mt-4 pt-lg-2 mb-4" method="post">
                                <input type="email" name="email" placeholder="Email Address" required="" />
                                <button><span class="fa fa-paper-plane" aria-hidden="true"></span></button>
                            </form>
                            <p>Subscribe to our mailing list and get updates to your email inbox.</p>
                        </div>
                    </div>
                    <div class="w3l-copyright text-center mt-lg-5 mt-sm-4 pt-md-4 pt-3">
                        <p class="copy-footer-29">© AgrowGrow. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
            <footer />
        </div >
    )
}

export default Index
